
import React from "react";

const DocumentThemeContext = React.createContext();

export default DocumentThemeContext;
